import produce from "immer"
import type { PagingActions, PagingOptions } from "../../models/types"
import { loadPagingOptions } from "../../utils/sort-table.utils"
import { REGION_LOAD, REGION_LOAD_DEFAULT, REGION_LOAD_LIST, REGION_LOAD_LIST_OPTIONS } from "./region.actions"
import type { IRegionState, Region, RegionActions } from "./region.types"

const regionInitialState: IRegionState = {
  regions: [],
  region: getEmptyRegion(),
  pagingOptions: {
    currentPage: 0,
    pageSize: 10,
    totalPages: 0
  }
}

export function regionReducer(
  currentState: IRegionState | undefined,
  action: RegionActions | PagingActions
): IRegionState {
  const state = currentState ?? regionInitialState
  switch (action.type) {
    case REGION_LOAD_DEFAULT: {
      return loadRegion(state, getEmptyRegion())
    }
    case REGION_LOAD_LIST: {
      return loadRegionList(state, action.payload as Region[])
    }
    case REGION_LOAD: {
      return loadRegion(state, action.payload as Region)
    }
    case REGION_LOAD_LIST_OPTIONS: {
      return loadPagingOptions(state, action.payload as PagingOptions)
    }
    default: {
      return state
    }
  }
}

function loadRegionList(currentState: IRegionState, regions: Region[]): IRegionState {
  return produce(currentState, (draftState: IRegionState) => {
    draftState.regions = regions
  })
}

function loadRegion(currentState: IRegionState, region: Region): IRegionState {
  return produce(currentState, (draftState: IRegionState) => {
    draftState.region = region
  })
}

function getEmptyRegion(): Region {
  return {
    name: "",
    chapterId: " ",
    licenceIds: [],
    order: 0
  }
}
